/**
 * ログユーティリティ
 * 開発環境のみログを出力し、本番環境では出力しない
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * 開発環境のみログを出力
 */
export const devLog = (...args: any[]) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * 開発環境のみエラーログを出力
 */
export const devError = (...args: any[]) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

/**
 * 開発環境のみ警告ログを出力
 */
export const devWarn = (...args: any[]) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

/**
 * 常にログを出力（本番環境でも重要なログ）
 */
export const prodLog = (...args: any[]) => {
  console.log(...args);
};

/**
 * 常にエラーログを出力（本番環境でも重要なエラー）
 */
export const prodError = (...args: any[]) => {
  console.error(...args);
};

export default {
  dev: devLog,
  error: devError,
  warn: devWarn,
  prod: prodLog,
  prodError,
};

